import { MandatOrigine } from './mandat_origine';
import { formatDate } from '@angular/common';
export class Mandat {

    mdt_id: string;
    mdt_numero: string;
    mdt_date_echeance: string;
    mdt_date_echeance_exclusivite: string;
    mdt_origine_id: string;
    mdt_type_avenant: string;
    mdt_actif: string;
    origine: MandatOrigine;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.mdt_id                        = data['mdt_id'] ? data['mdt_id'] : null;
        this.mdt_numero                    = data['mdt_numero'] ? data['mdt_numero'] : null;
        this.mdt_date_echeance             = data['mdt_date_echeance'] ? data['mdt_date_echeance'] : this.initDate();
        this.mdt_date_echeance_exclusivite = data['mdt_date_echeance_exclusivite'] ? data['mdt_date_echeance_exclusivite'] : this.initDate();
        this.mdt_origine_id                = data['mdt_origine_id'] ? data['mdt_origine_id'] : null;
        this.mdt_type_avenant              = data['mdt_type_avenant'] ? data['mdt_type_avenant'] : null;
        this.mdt_actif                     = data['mdt_actif'] ? data['mdt_actif'] : null;
        this.origine                       = data['origine'] ? new MandatOrigine(data['origine']) : new MandatOrigine();
    }

    initDate() {
        // Ajout un an et un jour à la date du jour
        const today = new Date();
        const date = new Date((today.getFullYear() + 1), today.getMonth(), (today.getDate() + 1));

        return formatDate(date, 'yyyy-MM-dd', 'en-US');
    }

}
